import {
  button_styles_default
} from "./chunk.FTSKMGHS.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  mixinThemeDetection
} from "./chunk.5OVLHNGV.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  l as l2,
  n as n2
} from "./chunk.47PJ6NWT.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/button/button.ts
import { t as t2 } from "i18next";
var FadvButton = class extends mixinThemeDetection(s) {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "caret", "prefix", "suffix", "split");
    this.hasFocus = false;
    this.isHovered = false;
    this.variant = "primary";
    this.size = "medium";
    this.caret = false;
    this.disabled = false;
    this.loading = false;
    this.outline = false;
    this.pill = false;
    this.circle = false;
    this.type = "button";
    this.block = false;
    this.rectangle = false;
    this.splitLabel = t2("components:button.options");
  }
  get labelType() {
    return `label-${this.size}`;
  }
  connectedCallback() {
    super.connectedCallback();
    this.updateComplete.then(() => {
      this.updateIcon();
    });
  }
  click() {
    this.button.click();
  }
  focus(options) {
    this.button.focus(options);
  }
  blur() {
    this.button.blur();
  }
  handleBlur() {
    this.hasFocus = false;
    emit(this, "sl-blur");
  }
  handleFocus() {
    this.hasFocus = true;
    emit(this, "sl-focus");
  }
  handleClick(event) {
    if (this.disabled || this.loading) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  handleSplitClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }
  updateIcon() {
    var _a, _b;
    if (this.outline && this.shadowRoot) {
      const prefixSlot = ((_a = this.shadowRoot.querySelector("slot[name='prefix']")) == null ? void 0 : _a.assignedElements()) || [];
      const suffixSlot = ((_b = this.shadowRoot.querySelector("slot[name='suffix']")) == null ? void 0 : _b.assignedElements()) || [];
      [...prefixSlot, ...suffixSlot, this.caretElement].forEach((e2) => {
        if (!e2)
          return;
        let icon;
        if (hasTag(e2, "fadv-icon")) {
          icon = e2;
        } else {
          icon = e2.querySelector("fadv-icon");
        }
        if (!icon)
          return;
        icon.foreground = this.isHovered ? void 0 : this.variant;
      });
    }
  }
  handleMouseenter() {
    this.isHovered = true;
    this.updateIcon();
  }
  handleMouseleave() {
    this.isHovered = false;
    this.updateIcon();
  }
  getThemeDefaults() {
    return {
      "c-elements": {
        pill: true
      },
      "e-elements": {
        pill: false
      }
    };
  }
  renderCaret() {
    if (!this.caret && !this.hasSlot.test("caret") || this.hasSlot.test("split"))
      return w;
    return n2`<span part="caret" class="button__caret"><slot name="caret"><fadv-icon library="solid" name="chevron-down"></fadv-icon></slot></span>`;
  }
  renderSpinner() {
    if (!this.loading)
      return w;
    return n2`<span class="button__spinner"><fadv-spinner></fadv-spinner></span>`;
  }
  renderSplit() {
    if (!this.hasSlot.test("split"))
      return w;
    if (this.variant === "text")
      return w;
    return n2`<fadv-dropdown hoist placement="bottom-end" distance="7" @click=${this.handleSplitClick} class="button__split-dropdown"><button part="base" class="button__split" ?disabled=${this.disabled} slot="trigger" aria-label=${this.splitLabel}><fadv-icon library="solid" name="chevron-down"></fadv-icon></button><slot name="split"></slot></fadv-dropdown>`;
  }
  render() {
    const tag = this.href ? l2`a` : l2`button`;
    return n2`<span class=${o({
      button: true,
      "button--primary": this.variant === "primary",
      "button--secondary": this.variant === "secondary",
      "button--tertiary": this.variant === "tertiary",
      "button--success": this.variant === "success",
      "button--neutral": this.variant === "neutral",
      "button--warning": this.variant === "warning",
      "button--danger": this.variant === "danger",
      "button--text": this.variant === "text",
      "button--monochrome": this.variant === "monochrome",
      "button--small": this.size === "small",
      "button--medium": this.size === "medium",
      "button--large": this.size === "large",
      "button--caret": this.caret || this.hasSlot.test("caret"),
      "button--rectangle": this.rectangle,
      "button--block": this.block,
      "button--circle": this.circle,
      "button--disabled": this.disabled || this.loading,
      "button--focused": this.hasFocus,
      "button--loading": this.loading,
      "button--standard": !this.outline,
      "button--outline": this.outline,
      "button--pill": this.pill,
      "button--has-label": this.hasSlot.test("[default]"),
      "button--has-prefix": this.hasSlot.test("prefix"),
      "button--has-suffix": this.hasSlot.test("suffix"),
      "button--has-split": this.hasSlot.test("split"),
      "button--hover": this.isHovered
    })} ><${tag} class="button__interior" aria-label=${l((this.caret || this.hasSlot.test("caret")) && !this.hasSlot.test("[default]") ? t2("components:button.trigger") : void 0)} ?disabled=${this.disabled} type=${this.type ? this.type : "button"} name=${l(this.href ? void 0 : this.name)} value=${l(this.href ? void 0 : this.value)} href=${l(this.href ? this.href : void 0)} target=${l(this.href ? this.target : void 0)} download=${l(this.href ? this.download : void 0)} rel=${l(this.href && this.target ? "noreferrer noopener" : void 0)} role=${l(this.href ? "button" : void 0)} aria-disabled=${this.disabled ? "true" : "false"} tabindex=${this.disabled ? "-1" : "0"} @blur=${this.handleBlur} @focus=${this.handleFocus} @click=${this.handleClick} @mouseenter=${this.handleMouseenter} @mouseleave=${this.handleMouseleave} ><span part="prefix" class="button__prefix"><slot name="prefix"></slot></span>${this.renderSpinner()}<span type="${this.labelType}" part="label" class="button__label"><slot></slot></span><span part="suffix" class="button__suffix"><slot name="suffix"></slot></span>${this.renderCaret()}</${tag}>${this.renderSplit()}</span><span part="badge" class="button__badge"><slot name="badge"></slot></span>`;
  }
};
FadvButton.styles = button_styles_default;
__decorateClass([
  i(".button__interior")
], FadvButton.prototype, "button", 2);
__decorateClass([
  i(".button__caret fadv-icon")
], FadvButton.prototype, "caretElement", 2);
__decorateClass([
  t()
], FadvButton.prototype, "hasFocus", 2);
__decorateClass([
  t()
], FadvButton.prototype, "isHovered", 2);
__decorateClass([
  e({ reflect: true })
], FadvButton.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], FadvButton.prototype, "size", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButton.prototype, "caret", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButton.prototype, "disabled", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButton.prototype, "loading", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButton.prototype, "outline", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvButton.prototype, "pill", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButton.prototype, "circle", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButton.prototype, "type", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvButton.prototype, "block", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvButton.prototype, "rectangle", 2);
__decorateClass([
  e()
], FadvButton.prototype, "name", 2);
__decorateClass([
  e()
], FadvButton.prototype, "value", 2);
__decorateClass([
  e()
], FadvButton.prototype, "href", 2);
__decorateClass([
  e()
], FadvButton.prototype, "target", 2);
__decorateClass([
  e()
], FadvButton.prototype, "download", 2);
__decorateClass([
  e()
], FadvButton.prototype, "splitLabel", 2);
FadvButton = __decorateClass([
  n("fadv-button")
], FadvButton);

export {
  FadvButton
};
